export const coerceDurationToSeconds = value => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return 0;

    if (trimmed.includes(':')) {
      const parts = trimmed.split(':').map(part => part.trim());
      if (parts.length > 3) return 0;

      let totalSeconds = 0;
      for (const part of parts) {
        const numeric = Number(part);
        if (!Number.isFinite(numeric)) return 0;
        totalSeconds = totalSeconds * 60 + numeric;
      }
      return totalSeconds;
    }

    const numeric = Number(trimmed);
    return Number.isFinite(numeric) ? numeric : 0;
  }

  return 0;
};
